<template>
    <h1>Telepresence Analytics</h1>
</template>
<script>
export default {
    name: 'telepresenceAnalytics'
    
}
</script>